import {Box, Flex, Text, Title} from 'exsportia-components'
import {useFormikContext} from 'formik'
import {FC, useCallback} from 'react'
import {DateTime} from 'luxon'

import {SignUpFormType} from '../../../services/auth/forms/sign-up-form'
import {useAppLoading} from '../../../services/global/hooks'
import {Button} from '../../../ui/components/button/button'
import {DOBPicker} from '../../../ui/components/dob-picker/dob-picker'
import {useLocale} from '../../../utils/i18n'

type DobSignUpStepProps = {
  handleGoToNextStep: () => void
  backAction?: (e: Event) => void
}

export const DobSignUpStep: FC<DobSignUpStepProps> = ({handleGoToNextStep, backAction}) => {
  const {l} = useLocale()
  const {isLoading} = useAppLoading()
  const {setFieldValue, values} = useFormikContext<SignUpFormType>()

  const setDob = useCallback((value: DateTime) => {
    setFieldValue('dob', value).catch(e => console.log(e))
  }, [setFieldValue])

  return (
    <Box pb={'24px'}>
      <Flex mb='8px'>
        <Title
          text={l('dob')}
          styleType='h2'
        />
      </Flex>
      <Flex mb='16px'>
        <Text text={l('enter_your_dob', {caseAction: 'capitalize'})} />
      </Flex>

      <Box mb='16px' px='16px'>
        <DOBPicker
          value={values.dob as DateTime || null}
          onChange={setDob}
        />
      </Box>

      <Flex
        gap='16px'
        mt={'16px'}
      >
        {backAction && (
          <Box style={{flex: 1}}>
            <Button
              disabled={isLoading}
              type='secondary'
              // @ts-ignore
              onClick={backAction}
            >
              {l('back', {defaultMessage: 'Back', caseAction: 'capitalize'})}
            </Button>
          </Box>
        )}
        <Box style={{flex: 1}}>
          <Button
            onClick={handleGoToNextStep}
            disabled={isLoading}
          >
            {l('continue', {defaultMessage: 'Continue', caseAction: 'capitalize'})}
          </Button>
        </Box>
      </Flex>
    </Box>
  )
}
